import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppComponent } from '../app.component';
import { bmxurl } from 'src/globals';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { booking_returndata } from 'src/types/booking_returndata';
import { BusyService } from '../_services/busy.service';
import { AuthService } from '@auth0/auth0-angular';
import { GlobalService } from '../_services/global.service';

@Component({
  selector: 'app-search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SearchComponent implements OnInit {

  ListBookings: any[];
  ListBookingsGlobal: any[];
  bmxurl: string;
  VenueID: string = localStorage.getItem("SmartVenueID")!;
  CreateUpdateResponse: any;
  DisabledListResource: any;
  checked: boolean = true;
  showDisabled: boolean = false;
  selectedItems: any;
  BookingDate: Date;
  httpResponse: any;
  searchCritera: string = "";
  selectedItem: any;
  selectedAction: any;

  screenwidth: number = window.innerWidth;
  screenheight: number = window.innerHeight;

  get useMobileView(): boolean {
    if (this.screenwidth <= 768) return true;
    return this.screenwidth <= 1024 && this.screenheight > this.screenwidth;
  }

  CompletedLoading: boolean = false;
  AccessAllowed: boolean = false;

  currentpage: number = localStorage.getItem("CurrentSearchPage") == null ? 0 : Number(localStorage.getItem("CurrentSearchPage"));

  CurrencySymbol: string = localStorage.getItem("Currency") == null ? "GBP" : localStorage.getItem("Currency")!;

  constructor(
    private http: HttpClient, 
    private appComp: AppComponent, 
    private router: Router, 
    private messageService: MessageService, 
    private busyService: BusyService,
    private auth: AuthService,
    private globalService: GlobalService,
    private route: ActivatedRoute) { 
    }

  ngOnInit(): void {

    this.globalService.setSmallScreenMenu(false);

    addEventListener("resize", () => {
      this.screenwidth = window.innerWidth;
      this.screenheight = window.innerHeight;
    });

    localStorage.removeItem("screenMemoryBookingss");
    localStorage.removeItem("screenMemoryEvents");
    
    let qssearchparam = "";
    this.route.queryParams
      .subscribe(params => {
        this.searchCritera = params.crit;
        this.showSearchResults(this.showDisabled);
      }
    );
  }

  toggleDisabled(){
    localStorage.removeItem("SearchResults");
    this.showSearchResults(!this.showDisabled);
  }

  mobileToggleDisabled() {
    this.showDisabled = !this.showDisabled;
    localStorage.removeItem("SearchResults");
    this.showSearchResults(this.showDisabled);
  }

  onPageChange(event){
    this.currentpage = event.first;
  }

  editdatanew(ID){

    localStorage.setItem("CurrentSearchPage", this.currentpage.toString());

    this.router.navigate(
      ['/editbooking/' + ID],
      { queryParams: { fs: 'true' } }
    );
  }

  showSearchResults(showdis)
  {
    if(localStorage.getItem("SearchResults") == null)
    {
      this.busyService.busy();

      const bookingRefPattern = /^[a-zA-Z]{3}-\d{6}-[a-zA-Z0-9]{6}$/;

      if(this.searchCritera && bookingRefPattern.test(this.searchCritera))
      { 
        showdis = true;
      }

      this.http.get(bmxurl + "Booking/Search/" + this.VenueID + "/" + this.searchCritera + "/" + showdis).subscribe(response => {
        try{
          this.CreateUpdateResponse = (response as booking_returndata);
          this.ListBookings = this.CreateUpdateResponse.data;

          //filter out bookings in progress
          this.ListBookings = this.ListBookings.filter(booking => booking.inProgress == false);
          localStorage.setItem("SearchResults",  JSON.stringify(this.ListBookings))
        }
        catch{
          this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'Failed to get bookings'});
        }
        finally{
          this.busyService.idle();
        }
      }, error => {
        this.messageService.add({severity:'error', summary:'Error getting bookings', detail: 'An error occurred getting Bookings'});
        this.busyService.idle();
      });
    }
    else{
      this.ListBookings = (JSON.parse(localStorage.getItem("SearchResults")) as any[]);
    }
  }

  disableData(BookingID)
  {
    if (confirm("Are you sure you want to disable this booking?"))
     {
        this.http.delete(bmxurl + "Booking/" + this.VenueID + "/" + BookingID).subscribe(response => {
          this.CreateUpdateResponse = response
          if(this.CreateUpdateResponse.succeeded)
          {
            this.messageService.add({severity:'success', summary:'Disabled', detail:'Booking successfully disabled'});
            this.showSearchResults(false);
          }
        }, error => {
          this.messageService.add({severity:'error', summary:'Not Disabled', detail: 'An error occurred disabling this Booking'});
        })
      }
  }


}
